import { render, staticRenderFns } from "./DiagramForm.vue?vue&type=template&id=630646c2&"
import script from "./DiagramForm.vue?vue&type=script&lang=js&"
export * from "./DiagramForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports